export class AddressHttp {
    /**
     * Fetch addresses
     * @param code
     * @returns {Promise<AxiosResponse<any>>}
     */
    static async fetchAddresses(code) {
        try {
            return await window.axios.get(`postcode/${code}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
